const state = {
  loading: false,
  errorData: null,
  respGuest: null,
  alert: {
    msg: "",
    show: false,
    type: "success"
  }
};

const getters = {
  isLoading: state => state.loading,
  errorData: state => state.errorData,
  respGuest: state => state.respGuest,
  alert: state => state.alert
};

const mutations = {
  SET_LOADING: (state, status) => {
    state.loading = status;
  },
  SET_ERROR: (state, errorData) => {
    state.errorData = errorData;
  },
  SET_RESP: (state, value) => {
    state.respGuest = value;
  },
  SET_ALERT: (state, value) => {
    state.alert = value;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
